import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as saleApi from "../api/sale.api"

export const fetchSale = async payload => {
  try {
    const { data } = await saleApi.fetchSale(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter dados do pedido."
    })
    throw error
  }
}

export const startSale = async payload => {
  try {
    const { data } = await saleApi.startSale(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao iniciar registro do pedido."
    })
    throw error
  }
}

export const saveSale = async payload => {
  try {
    const { data } = await saleApi.saveSale(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao salvar do pedido."
    })
    throw error
  }
}

export const editSale = async (id, payload) => {
  try {
    const { data } = await saleApi.editSale(id, payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao editar pedido."
    })
    throw error
  }
}

export const saveSaleProperties = async payload => {
  try {
    const { data } = await saleApi.saveSaleProperties(payload)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const ratingSale = async payload => {
  try {
    const { data } = await saleApi.ratingSale(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter dados do pedido."
    })
    throw error
  }
}

export const searchInProgressSale = async document => {
  try {
    const data = await saleApi.searchInProgressSale(document)
    return data
  } catch (error) {
    throw error
  }
}

export const fetchSaleFlows = async payload => {
  try {
    const { data } = await saleApi.fetchSaleFlows(payload)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fetchChainOptions = async () => {
  try {
    const { data } = await saleApi.fetchChainOptions()
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fetchPosOptions = async params => {
  try {
    const { data } = await saleApi.fetchPosOptions(params)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fetchSellerByPos = async uuid => {
  try {
    const { data } = await saleApi.fetchSellerByPos(uuid)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updateSale = async (uuid, payload) => {
  try {
    await saleApi.updateSale(uuid, payload)
    window.$vue.$toast({
      type: "success",
      title: "Pedido atualizado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao atualizar dados do pedido."
    })
    throw error
  }
}
